import React, { useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import axios from 'axios';
import { FirestoreCollection } from '@react-firebase/firestore';
import Media from 'react-media';
import { Link as ScrollLink } from 'react-scroll';

import ProjectPlanner from '../../Components/ProjectPlanner/ProjectPlanner';
import LoadingSection from '../../Components/LoadingSection/LoadingSection';

import { ReactComponent as Check } from '../../Components/Icons/check.svg';
import { ReactComponent as Home } from '../../Components/Icons/home.svg';
import { ReactComponent as Right } from '../../Components/Icons/right.svg';
import { ReactComponent as Direction } from '../../Components/Icons/direction.svg';
import { ReactComponent as Level } from '../../Components/Icons/level.svg';
import { ReactComponent as MapPin } from '../../Components/Icons/mapPin.svg';
import { ReactComponent as Polygon } from '../../Components/Icons/polygon.svg';
import { ReactComponent as InANutshell } from '../../Components/Icons/inANutshell.svg';

import './Vacancy.scss';
import ReactTooltip from 'react-tooltip';
import { useSessionStorage } from '../../hooks/useSessionStorage';

const url = (id: string) => `https://my.gisua.com/vacancy/${id}?api_key=0ead9a6a-cab8-496f-a976-eb2b35f225fa`;

interface VacancyDataProps {
	name: string;
	seniority: string[];
	job_tags: string[];
	city: string[];
	country: string[];
	direction: string[];
	about_company: {
		title: string;
		string: string | boolean;
	};
	requirements: {
		title: string;
		list: string[];
	};
	niceToHave: {
		title: string;
		list: string[];
	};
	responsibilities: {
		title: string;
		list: string[];
	};
	requiredSkills: {
		title: string;
		list: string[];
	};
	otherSkills: {
		title: string;
		list: string[];
	};
	About_GISUA: {
		title: string;
		string: string;
	};
	weOffer: {
		title: string;
		list: {
			info: string;
			desc: string;
		}[];
	};
	in_a_nutshell: string[];
	in_a_nutshell_big: string[];
}

export default function Vacancy() {
	const { location } = useHistory();
	const id = location.pathname.substring(location.pathname.lastIndexOf('_') + 1);

	const [data, setData] = useState<VacancyDataProps>();
	const [isLoading, setIsLoading] = useState(true);
	const [language] = useSessionStorage('language', '');

	useEffect(() => {
		const fetchData = async () => {
			setIsLoading(true);

			const result = await axios(url(id));

			setData(result.data);
			setIsLoading(false);
		};

		fetchData();
	}, [id]);

	return (
		<FirestoreCollection path="/vacancies/">
			{(vacancyData) => {
				if (vacancyData.isLoading) {
					return;
				}
				return (
					<div className="vacancyPage">
						<div
							className="vacancyImage"
							style={{
								backgroundImage:
									vacancyData.value[0].headerVacancyImage && `url(${vacancyData.value[0].headerVacancyImage.lg.src})`,
							}}
						>
							<div className="vacancyTitleWrapper">
								<div className="vacancyHeaderTitle">{data && data.name}</div>
							</div>
						</div>
						<div className="vacancyContentWrapper">
							{isLoading ? (
								<LoadingSection />
							) : (
								data && (
									<div className="vacancyContent">
										<div className="vacancyBreadcrumb">
											<Link to="/">
												<Home />
											</Link>
											<span className="vacancyBreadcrumbArrow">
												<Right />
											</span>
											<Link to="/vacancies">{language === 'ua' ? 'Вакансії' : 'Vacancies'}</Link>
											<Media query="(min-width: 900px)">
												{(matches) =>
													matches && (
														<>
															<span className="vacancyBreadcrumbArrow">
																<Right />
															</span>
															<span>{data.name}</span>
														</>
													)
												}
											</Media>
										</div>
										<div className="vacancyMainTitle">{data.name}</div>
										<div className="vacancyMainDescription">
											<div className="vacancyMainDescriptionContent">
												{data.direction.length > 0 && (
													<div className="vacancyMainDescriptionRow">
														<div className="vacancyMainDescriptionName">
															<Direction />
														</div>
														<div className="vacancyMainDescriptionNameDesc">
															{[data.direction].map((sen) => sen).join(', ')}
														</div>
													</div>
												)}
												{data.seniority.length > 0 && (
													<div className="vacancyMainDescriptionRow">
														<div className="vacancyMainDescriptionName">
															<Level />
														</div>
														<div className="vacancyMainDescriptionNameDesc">
															{[data.seniority].map((sen) => sen).join(', ')}
														</div>
													</div>
												)}
												{(data.city.length > 0 || data.country.length > 0) && (
													<div className="vacancyMainDescriptionRow">
														<div className="vacancyMainDescriptionName">
															<MapPin />
														</div>
														<div className="vacancyMainDescriptionNameDesc">
															{data.city.map((city: string) => city).join(', ')}
															{data.city.length > 0 && ', '}
															{data.country.map((country: string) => country).join(', ')}
														</div>
													</div>
												)}
											</div>
											<div className="inANutshellWrapper">
												<InANutshell className="inANutshellImage" />
												<div className="inANutshellMessageWrapper">
													{data.job_tags && (
														<div className="inANutshellMessage">
															{data.job_tags.map((tag: string) => tag).join(', ')}
															<Polygon />
														</div>
													)}
													{data.in_a_nutshell[0] !== 'False' && data.in_a_nutshell[0] !== '' && (
														<div className="inANutshellMessage">
															{data.in_a_nutshell[0]}
															<Polygon />
														</div>
													)}
													{data.in_a_nutshell_big[0] !== 'False' && data.in_a_nutshell_big[0] !== '' && (
														<div className="inANutshellMessage">
															{data.in_a_nutshell_big[0]}
															<Polygon />
														</div>
													)}
												</div>
											</div>
											<div className="vacancyButtonsWrapper">
												<ScrollLink to="projectPlannerSectionScroll" smooth={true} className="vacancyJoinButton" offset={-100}>
													{language === 'ua' ? 'Відгукнутися' : 'Apply via site'}
												</ScrollLink>
												{/* <a
													href="https://www.linkedin.com/company/global-it-support/mycompany/"
													target="_blank"
													rel="noopener noreferrer"
													className="vacancyLinkedinButton"
												>
													<LinkedinBtn /> {language === 'ua' ? 'Прийняти через linkedin' : 'Apply via linkedin'}
												</a> */}
											</div>
										</div>
										{data.about_company && data.about_company.string !== false && (
											<div className="vacancyList">
												<div
													className="vacancyHeadTitle"
													dangerouslySetInnerHTML={{ __html: `${data.about_company.title}:` }}
												></div>
												<div
													className="vacancyListDescription"
													dangerouslySetInnerHTML={{ __html: `${data.about_company.string}` }}
												></div>
											</div>
										)}
										{data.requirements && data.requirements.list[0] !== 'False' && data.requirements.list[0] !== '' && (
											<div className="vacancyList">
												<div
													className="vacancyHeadTitle"
													dangerouslySetInnerHTML={{ __html: `${data.requirements.title}:` }}
												></div>
												{data.requirements.list.map((requirement, index) => (
													<li key={index}>
														<span dangerouslySetInnerHTML={{ __html: `${requirement}` }}></span>
													</li>
												))}
											</div>
										)}
										{data.niceToHave && data.niceToHave.list[0] !== 'False' && data.niceToHave.list[0] !== '' && (
											<div className="vacancyList">
												<div
													className="vacancyHeadTitle"
													dangerouslySetInnerHTML={{ __html: `${data.niceToHave.title}:` }}
												></div>
												{data.niceToHave.list.map((niceToHave, index) => (
													<li key={index}>
														<span dangerouslySetInnerHTML={{ __html: `${niceToHave}` }}></span>
													</li>
												))}
											</div>
										)}
										{data.responsibilities &&
											data.responsibilities.list[0] !== 'False' &&
											data.responsibilities.list[0] !== '' && (
												<div className="vacancyList">
													<div
														className="vacancyHeadTitle"
														dangerouslySetInnerHTML={{ __html: `${data.responsibilities.title}:` }}
													></div>
													{data.responsibilities.list.map((responsibilitie, index) => (
														<li key={index}>
															<span dangerouslySetInnerHTML={{ __html: `${responsibilitie}` }}></span>
														</li>
													))}
												</div>
											)}
										{data.requiredSkills && data.requiredSkills.list[0] !== 'False' && data.requiredSkills.list[0] !== '' && (
											<div className="vacancyList">
												<div
													className="vacancyHeadTitle"
													dangerouslySetInnerHTML={{ __html: `${data.requiredSkills.title}:` }}
												></div>
												{data.requiredSkills.list.map((skill, index) => (
													<li key={index}>
														<span dangerouslySetInnerHTML={{ __html: `${skill}` }}></span>
													</li>
												))}
											</div>
										)}
										{data.otherSkills && data.otherSkills.list[0] !== 'False' && data.otherSkills.list[0] !== '' && (
											<div className="vacancyList">
												<div
													className="vacancyHeadTitle"
													dangerouslySetInnerHTML={{ __html: `${data.otherSkills.title}:` }}
												></div>
												{data.otherSkills.list.map((otherSkill, index) => (
													<li key={index}>
														<span dangerouslySetInnerHTML={{ __html: `${otherSkill}` }}></span>
													</li>
												))}
											</div>
										)}
										{data.About_GISUA && data.About_GISUA.string !== '' && (
											<div className="vacancyList">
												<div
													className="vacancyHeadTitle"
													dangerouslySetInnerHTML={{ __html: `${data.About_GISUA.title}:` }}
												></div>
												<div
													className="vacancyListDescription"
													dangerouslySetInnerHTML={{ __html: `${data.About_GISUA.string}` }}
												></div>
											</div>
										)}
										{data.weOffer && data.weOffer.list[0].info !== 'False' && data.weOffer.list[0].info !== '' && (
											<div className="vacancyList">
												<div className="vacancyHeadTitle" dangerouslySetInnerHTML={{ __html: `${data.weOffer.title}:` }}></div>
												{data.weOffer.list.map(
													(offer, index) =>
														offer.info !== '' && (
															<div data-tip data-for={offer.info.replace(' ', '-')} key={index} className="vacancyCheckList">
																<Check />
																<span className="offerInfo" dangerouslySetInnerHTML={{ __html: `${offer.info}` }}></span>
																{offer.desc !== '' && (
																	<ReactTooltip
																		className="offerTooltip"
																		place="right"
																		id={offer.info.replace(' ', '-')}
																		type="light"
																	>
																		<span>{offer.desc}</span>
																	</ReactTooltip>
																)}
															</div>
														)
												)}
											</div>
										)}
									</div>
								)
							)}
						</div>
						<ProjectPlanner vacancyId={id} {...vacancyData.value[0].planner} />
					</div>
				);
			}}
		</FirestoreCollection>
	);
}
